<template>
    <div class="erpsku-input">
        <!-- <Poptip trigger="focus" v-if="multiple">
            <Input
                class="erpsku-input-input"
                v-model="erpSku"
                v-bind="inputProps"
                :readonly="showread == 'showyes' ? false : true"
                @on-blur="handlesearch"
            >
                <Icon
                    type="ios-search"
                    style="font-size: 16px; margin-right: 10px; cursor: pointer"
                    slot="suffix"
                    @click="handleShowErpSkuAndAsin"
                />
            </Input>
            <div slot="content">
                {{ erpSku || "多个可按逗号分隔输入，如erpsku1,erpsku2" }}
            </div>
        </Poptip> -->
        <Input
            class="erpsku-input-input"
            v-model="erpSku"
            v-bind="inputProps"
            :readonly="showread == 'showyes' ? false : true"
            @on-blur="handlesearch"
        >
            <Icon
                type="ios-search"
                style="font-size: 16px; margin-right: 10px; cursor: pointer"
                slot="suffix"
                @click="handleShowErpSkuAndAsin"
            />
        </Input>
        <compModal v-model="modalProps.show" v-bind="modalProps">
            <compErpSkuAndAsin
                :isManage="erpskutype == 'manage'"
                @on-data="handleSelectERPSKU"
                @on-close="modalProps.show = false"
            ></compErpSkuAndAsin>
        </compModal>
    </div>
</template>
<script>
import compErpSkuAndAsin from "./erpSkuAndAsin.vue";
export default {
    props: {
        value: {
            type: String,
        },
        inputProps: {
            type: Object,
        },
        showread: String,
        erpskutype: String,
    },
    components: {
        compErpSkuAndAsin,
    },
    watch: {
        value: {
            immediate: true,
            handler(val) {
                this.erpSku = val;
            },
        },
    },
    data() {
        return {
            row: {},
            erpSku: "",
            modalProps: {
                show: false,
                showFooter: false,
                title: this.$t("erp.product.product_query", {
                    defaultValue: "产品查询",
                }),
                width: 1000,
            },
        };
    },
    mounted() {},
    methods: {
        handleShowErpSkuAndAsin() {
            this.modalProps.show = true;
        },
        handlesearch() {
            this.$emit("on-data", { erpSku: this.erpSku });
        },
        handleSelectERPSKU(row) {
            this.$set(this.$data, "row", row);
            this.modalProps.show = false;
            this.row = row;
            this.erpSku = row.erpSku;
            this.$emit("on-data", row);
            this.$emit("on-change", row.erpSku);
        },
    },
};
</script>
<style lang="scss" scoped>
.erpsku-input {
    display: inline-block;
    width: 100%;

    &-input {
        width: 100%;
    }
}
</style>
